import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
  name: 'round'
})
export class RoundPipe implements PipeTransform {

  transform(input: any) {
    if (input) {
      return parseFloat(input).toFixed(1)
    }
    return null;
  }

}



// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/pipes/round.pipe.ts